import { Image, Text, View } from '@react-pdf/renderer'
import moment from 'moment'
import React from 'react'

function SoapNonWeb({ fillableData, styles, stylesSoap }) {
  return (
    <View style={{ ...styles.gapBox }}>
      <View
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          fontSize: 8,
        }}
      >
        <Image
          style={{ width: '110px', objectFit: 'cover' }}
          src="/paincare-web-v2.png"
        />
        <View style={styles.boxtitle}>
          <Text>2480 Liberty Street NE, Suite 180, Salem, OR 97301</Text>
        </View>
        <View style={styles.boxtitle}>
          <Text>Office: (503) 371-1010 Fax: (503) 371-0805</Text>
        </View>
        <View style={{ paddingTop: 20 }}>
          <Image
            style={{ width: '60px', objectFit: 'cover' }}
            src="/soapp.png"
          />
        </View>
      </View>
      <View
        style={{
          width: '450px',
          gap: '4px',
          marginTop: '-8px',
        }}
      >
        <Text style={{ lineHeight: 1.25, textAlign: 'justify' }}>
          The following are some questions given to patients who are on or being
          considered for medication for their pain. Please answer each question
          as honestly as possible. There are no right or wrong answers.
        </Text>
        <View
          style={{
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'start',
            width: '450px',
            paddingTop: '4px',
          }}
        >
          <View style={{ ...styles.table, width: '450px' }}>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  padding: 30,
                  paddingTop: 8,
                  paddingBottom: 8,
                  width: '100%',
                  gap: 6,
                }}
              >
                <View style={{ flexDirection: 'row' }}>
                  <Text style={{ fontWeight: 'bold', width: '40px' }}>
                    Name:
                  </Text>
                  {` `}
                  <Text style={{ ...styles.paddingLeftFormData }}>
                    {fillableData.namePatient ? fillableData.namePatient : ''}
                  </Text>
                </View>
                <View style={{ flexDirection: 'row', paddingTop: 6 }}>
                  <Text style={{ fontWeight: 'bold', width: '80px' }}>
                    Date of Birth:
                  </Text>
                  {` `}
                  <Text style={{ ...styles.paddingLeftFormData }}>
                    {fillableData?.DOB
                      ? moment(fillableData?.DOB).format('MM/DD/YYYY')
                      : ''}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  height: '62px',
                  backgroundColor: '#dddddd',
                }}
              >
                <Text style={stylesSoap.subBoxTitle}>Never</Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text style={stylesSoap.subBoxTitle}>Seldom</Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text style={stylesSoap.subBoxTitle}>Sometimes</Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text style={stylesSoap.subBoxTitle}>Often</Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text style={stylesSoap.subBoxTitle}>Very Often</Text>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  gap: 6,
                }}
              >
                <Text></Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text>0</Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text>1</Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text>2</Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text>3</Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  backgroundColor: '#dddddd',
                }}
              >
                <Text>4</Text>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>1.</Text>
                <Text>How often do you have mood swings?</Text>
              </View>
              <View style={stylesSoap.boxBorder}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howSwings === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={stylesSoap.boxBorder}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howSwings === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={stylesSoap.boxBorder}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howSwings === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={stylesSoap.boxBorder}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howSwings === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={stylesSoap.boxBorder}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howSwings === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>2.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have you felt a need for higher doses of medication
                  to treat your pain?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howHigh === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howHigh === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howHigh === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howHigh === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howHigh === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>3.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have you felt impatient with your doctors?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howImpatient === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howImpatient === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howImpatient === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howImpatient === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howImpatient === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>4.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have you felt that things are just too overwhelming
                  that you can't handle them?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howThings === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howThings === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howThings === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howThings === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howThings === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>5.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often is there tension in the home?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howTension === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howTension === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howTension === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howTension === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howTension === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>6.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have you counted pain pills to see how many are
                  remaining?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howPain === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howPain === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howPain === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howPain === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howPain === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>7.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have you been concerned that people will judge you
                  for taking pain medication?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcerned === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcerned === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcerned === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcerned === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcerned === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>8.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often do you feel bored?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howBored === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howBored === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howBored === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howBored === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howBored === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>9.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have you taken more pain medication than you were
                  supposed to?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howMedication === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howMedication === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howMedication === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howMedication === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder, paddingTop: 8 }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howMedication === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>10.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have you worried about being left alone?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howWorried === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howWorried === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howWorried === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howWorried === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howWorried === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                }}
              >
                <Text style={{ width: '20px' }}>11.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have you felt a craving for medication?
                </Text>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howCraving === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howCraving === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howCraving === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howCraving === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View style={{ ...stylesSoap.boxBorder }}>
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howCraving === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
            <View
              style={{
                margin: 'auto',
                flexDirection: 'row',
                width: '450px',
              }}
            >
              <View
                style={{
                  ...stylesSoap.boxBorderTitle,
                  width: '100%',
                  flexDirection: 'row',
                  borderBottom: 1,
                }}
              >
                <Text style={{ width: '20px' }}>12.</Text>
                <Text style={{ paddingRight: 18 }}>
                  How often have others expressed concern over your use of
                  medication?
                </Text>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  paddingTop: 8,
                  borderBottom: 1,
                }}
              >
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcern === 'Zero' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  paddingTop: 8,
                  borderBottom: 1,
                }}
              >
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcern === 'One' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  paddingTop: 8,
                  borderBottom: 1,
                }}
              >
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcern === 'Two' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  paddingTop: 8,
                  borderBottom: 1,
                }}
              >
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcern === 'Three' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
              <View
                style={{
                  ...stylesSoap.boxBorder,
                  paddingTop: 8,
                  borderBottom: 1,
                }}
              >
                <View style={styles.stylesCheckImage}>
                  {fillableData?.howConcern === 'Four' && (
                    <Image
                      style={{
                        ...styles.imgcheck,
                      }}
                      src="/check.png"
                    />
                  )}
                </View>
              </View>
            </View>
          </View>
        </View>
        <Text style={{ paddingTop: 6, lineHeight: 1.5, textAlign: 'justify' }}>
          ©2014 Inflexxion, Inc. Permission granted solely for use in published
          format by individual practitioners in clinical practice. No other uses
          or alterations are authorized or permitted by copyright holder.
          Permissions questions:{' '}
          <Text style={{ borderBottom: 1 }}>PainEDU@inflexxion.com.</Text> The
          SOAPP®-R was developed with a grant from the National Institutes of
          Health and an educational grant from Endo Pharmaceuticals.
        </Text>
        <View
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '450px',
            paddingTop: 25,
          }}
        >
          <Image
            style={{ width: '170px', objectFit: 'cover' }}
            src="/edu-logo.png"
          />
        </View>
      </View>
    </View>
  )
}

export default SoapNonWeb
